var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagMoldova(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9565 1.58763C20.853 0.5705 18.4931 0 16 0C13.5069 0 11.147 0.5705 9.0435 1.58763L7.65219 16L9.0435 30.4124C11.147 31.4295 13.5069 32 16 32C18.4931 32 20.853 31.4295 22.9565 30.4124L24.3478 16L22.9565 1.58763Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0435 1.58813C3.69163 4.17607 0 9.65664 0 15.9999C0 22.3433 3.69163 27.8238 9.0435 30.4118V1.58813Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9561 1.58813V30.4118C28.3079 27.8238 31.9996 22.3433 31.9996 15.9999C31.9996 9.65664 28.3079 4.17607 22.9561 1.58813Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5652 12.5887H17.7391C17.7391 11.6282 16.9605 10.8496 16 10.8496C15.0395 10.8496 14.2609 11.6282 14.2609 12.5887H10.4348C10.4348 13.5344 11.2586 14.301 12.2042 14.301H12.1472C12.1472 15.2467 12.9138 16.0134 13.8596 16.0134C13.8596 16.8507 14.4609 17.5465 15.2552 17.6952L13.9058 20.7416C14.5524 21.0044 15.259 21.1505 16 21.1505C16.7409 21.1505 17.4476 21.0044 18.0941 20.7416L16.7448 17.6952C17.5391 17.5465 18.1404 16.8507 18.1404 16.0134C19.0862 16.0134 19.8528 15.2467 19.8528 14.301H19.7958C20.7414 14.301 21.5652 13.5344 21.5652 12.5887Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14.9565L13.7391 16V18.087L16 19.4783L18.2609 18.087V16L16 14.9565Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7391 13.9131H18.2609V16H13.7391V13.9131Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMoldova);
export default __webpack_public_path__ + "static/media/flag_moldova.dad7367917f904c171f3fefd4860ac6e.svg";
export { ForwardRef as ReactComponent };